// extracted by mini-css-extract-plugin
export default {"video_layout":"VideoLayout_video_layout__F8gKy","back_btn":"VideoLayout_back_btn__VFKlW"};